import React from "react";
import styled from "styled-components";
import { FontWeight, content } from "@glossy";
import Navbar from "@komon/navigation/navbar";
import Switcher from "@komon/navigation/navbar/apps";
import NavbarAuto from "@komon/navigation/navbar/auto";
import NavbarButton from "@komon/navigation/navbar/button";
import Logo from "@komon/navigation/navbar/logo";
import { Locale } from "@linkfluence/models/locale";
import { Product } from "@linkfluence/models/product";
import Link from "@ui-kit/utils/link";
import { User } from "@radarly/models/user";
import logo from "../../../../assets/logos/header-logo.svg?raw";

export interface IProps {
  openProfile?: () => void;
  products?: Product[];
  loading?: boolean;
  scope?: React.ReactNode;
  warmups?: React.ReactNode;
  help?: React.ReactNode;
  features?: React.ReactNode;
  pages?: React.ReactNode;
  homeUrl?: string;
  locale: Locale;
  user: User;
}

const LogoText = styled.div`
  color: ${(props) => content(props, "secondary")};
  font-size: 20px;
  font-weight: ${FontWeight.Medium};
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 204px;
`;

const NavigationNavbar = ({
  warmups,
  openProfile,
  products = [],
  loading,
  scope,
  help,
  features,
  pages,
  homeUrl,
  locale,
  user,
}: IProps) => (
  <Navbar>
    <StyledLink url={homeUrl}>
      <Logo svg={logo} />
      <LogoText>Radarly</LogoText>
    </StyledLink>{" "}
    {!loading && pages}
    <NavbarAuto />
    {!loading && (
      <>
        {features}
        {scope}
        {warmups}
      </>
    )}
    <Switcher products={products} locale={locale} user={user} />
    {help}
    <div data-testid="profile-open">
      <NavbarButton
        glyph="user-fill"
        shape="disc"
        onClick={openProfile}
        iconSize={16}
      />
    </div>
  </Navbar>
);

export default NavigationNavbar;
